<template>
  <div>
    <v-client-table :columns="columns" :data="groupsWithId" :options="options" :theme="theme" id="dataTable">
      <b-button pill variant="outline-light" size="sm" slot="delete" slot-scope="props" @click.stop="confirmDelete(props.row)">
        <i class="fa fa-trash"></i>
      </b-button>
      <div slot="name" slot-scope="props">
        <router-link :to="{name: 'Group', params: {id: props.row.id}}">{{props.row.name}}</router-link>
      </div>      
      <div slot="child_row" slot-scope="props">
        Group Name : {{props.row.name}}
      </div>
    </v-client-table>

    <b-modal title="Delete Group" class="modal-warning" v-model="warningModal" @ok="deleteItem" ok-variant="warning">
      Users belong this group also will be affected?  Are you sure to delete?
    </b-modal>
  </div>
</template>

<script>
  import { ClientTable, Event } from 'vue-tables-2'

  export default {
    name: 'Groups',
    components: {
      ClientTable,
      Event
    },
    props: {
      userId: {
        type: String,
        required: false
      },
      deviceId: {
        type: String,
        required: false
      },
      searchOption: {
        type: Object,
        required: false,
      }      
    },    
    data: function() {
      return {
        idToDelete : null,
        warningModal: false,
        groups: null,
        columns: ['name', 'usersSize', 'limit', 'created', 'updated', 'delete'],
        options: {
          headings: {
            name: 'Name',
            usersSize: 'Members',
            limit: 'Limit members',
            created: 'Created',
            updated: 'Updated',
            delete: 'Delete'
          },
          sortable: ['name', 'usersSize', 'limit', 'created', 'updated'],
          filterable: ['name', 'usersSize', 'limit', 'created', 'updated'],
          sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
          templates: {
            created: (h, row, index) => {
                return (row.created && row.created.seconds) ?this.$moment.unix(row.created.seconds).format('YYYY-MM-DD HH:mm:ss'): '';
            },
            updated: (h, row, index) => {
                return (row.updated && row.updated.seconds) ?this.$moment.unix(row.updated.seconds).format('YYYY-MM-DD HH:mm:ss'): '';
            }
          },
          pagination: {
            chunk: 5,
            edge: false,
            nav: 'scroll'
          }
        },
        useVuex: false,
        theme: 'bootstrap4',
        template: 'default'
      }
    },
    created: function() {
      let query = this.$firebase.firestore().collection('groups')

      if (this.searchOption) {
        if (this.searchOption.name && this.searchOption.name.length > 3) {
          query = query.where('name', '==', this.searchOption.name)
        }
        if (this.searchOption.createdFrom && this.searchOption.createdTo) {
          query = query
          .where('created', '>=', this.$moment(this.searchOption.createdFrom, 'YYYY-MM-DD').startOf('day').toDate())
          .where('created', '<=', this.$moment(this.searchOption.createdTo, 'YYYY-MM-DD').endOf('day').toDate())
        }
      } 
      query = query.orderBy('created', 'desc').limit(1000)
      this.$bind('groups', query)
    },
    computed: {
        groupsWithId() {
            if (!this.groups) {
                return []
            }
            return this.groups.map(group => {
                return {...group, id: group.id}
            })
        },
    },
    methods: {
        confirmDelete(item) {
          if (!item) {
            return
          }
          this.idToDelete = item.id
          this.warningModal = true
        },
        deleteItem() {
          if (!this.idToDelete) return

          this.$firebase.firestore().collection('groups').doc(this.idToDelete).delete()
          .catch(error => {
            console.error('delete error: ', error)
          })
          this.warningModal = false
        }
    }
  };
</script>

<style lang="scss">
  #dataTable {
    width: 95%;
    margin: 0 auto;

    .VuePagination {
      text-align: center;
      justify-content: center;
    }

    .vue-title {
      text-align: center ;
      margin-bottom: 10px;
    }

    .VueTables__search-field {
      display: flex;
    }
    .VueTables__search-field input {
      margin-left: 0.25rem;
    }

    .VueTables__limit-field {
      display: flex;
    }

    .VueTables__limit-field select {
      margin-left: 0.25rem !important;
    }

    .VueTables__table th {
      text-align: center;
    }

    .VueTables__child-row-toggler {
      width: 16px;
      height: 16px;
      line-height: 16px;
      display: block;
      margin: auto;
      text-align: center;
    }

    .VueTables__child-row-toggler--closed::before {
      content: "+";
    }

    .VueTables__child-row-toggler--open::before {
      content: "-";
    }
  }

</style>
